import { z } from "zod";

/** BlockNote-compatible JSON shape without importing @blocknote/core on public routes. */
export type InlineContent =
  | string
  | Array<
      | string
      | {
          type?: string;
          text?: string;
          href?: string;
          styles?: Record<string, boolean | undefined>;
        }
    >;

export type EditorBlock = {
  id?: string;
  type?: string;
  content?: InlineContent;
  props?: Record<string, unknown>;
  children?: EditorBlock[];
};

export type EditorDoc = EditorBlock[];

export const editorDocSchema = z.array(z.record(z.unknown())).max(500);

export function parseEditorDocInput(input: unknown): EditorDoc | null {
  if (input == null) return null;
  const parsed = editorDocSchema.safeParse(input);
  if (!parsed.success) throw new Error("Invalid editor document");
  return parsed.data as EditorDoc;
}

export function hasEditorDoc(doc: unknown): doc is EditorDoc {
  return Array.isArray(doc) && doc.length > 0;
}

export function emptyEditorDoc(): EditorDoc {
  return [{ type: "paragraph", content: "" }];
}
